<template>
	<div>
		<div class="main">
			<div v-if="isVideo" class="video">
				<div class="layer"></div>
				<video-player class="vjs-custom-skin videoPlayer" :options="playerOptions"></video-player>
			</div>
			<div class="user">
				<p style="text-align: center;">報名人員（{{ isLive }}/{{ userList.length }}）</p>
				<div class="user-list">
					<p v-for="(item, index) in userList" :key="index" :class="item.isLive ? 'blue' : ''">
					<span class="userName">{{ item.name }}</span>
					<span class="isLiveTime">{{ item.isLiveTime }}</span>
					</p>
				</div>
			</div>
		</div>
		<el-button @click="$router.back()">結束觀看</el-button>
	</div>
</template>

<script>
import 'video.js/dist/video-js.css';
import 'videojs-flash';
import { videoPlayer } from 'vue-video-player'; // 有多个输出值，引入花括号
export default {
	data() {
		return {
			playerOptions: {
				playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				autoplay: false, //如果true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 导致视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						type: 'video/mp4',
						src: '' //视频url地址
					}
				],
				// poster: '../../static/image/thumb_1_1380_460_20181009043014983386.jpg', //你的封面地址
				// width: document.documentElement.clientWidth,
				notSupportedMessage: '此視頻暫時無法播放，請稍後再試', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				// controlBar: {
				// 	timeDivider: true,
				// 	durationDisplay: true,
				// 	remainingTimeDisplay: false,
				// 	fullscreenToggle: true //全屏按钮
				// }
			},
			liveId: '',
			msg: {},
			isVideo: false,
			userList: [],
			isLive: 0
		};
	},
	components: {
		videoPlayer
	},
	created() {
		this.liveId = sessionStorage.getItem('liveId');
		this.axios({
			url:'/manage/startEndLive',
			params: {
				type: 3,
				id: this.liveId
			},
			method: 'post'
		}).then(res => {
			if (res) {
				this.msg = res.result;
				this.playerOptions.sources[0].src = this.msg.liveFile;
				this.isVideo = true;
				this.$nextTick(() => {
					$('#pageHead').text(this.msg.sectionName);
				});
			}
		});
		this.getUserNum();
	},
	methods: {
		getUserNum() {
			this.axios.get('/manage/getManHistoricalAudienceList/noLoad?id=' + this.liveId).then(res => {
				if (res) {
					let list = res.result,
						isLive = 0;
					list.forEach(item => {
						if (item.isLive) {
							isLive++;
						}
					});
					this.isLive = isLive;
					this.userList = list;
				}
			});
		}
	}
};
</script>
<style scoped>
.main {
	display: flex;
	justify-content: space-between;
}
.video {
	width: 60vw;
	position: relative;
	/* margin-top: -5vh; */
	/* z-index: -1; */
}
.video-js .vjs-icon-placeholder {
    width: 100%;
    height: 100%;
    display: block;
}
.video-player.vjs-custom-skin.videoPlayer{
	height: 100%;
}
.videoPlayer >>> .video-js.vjs-fluid{
	height: 100%;
}
/* .layer {
	height: 5vh;
	width: 100%;
	background-color: white;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
} */
.user {
	width: 20vw;
	height: 70vh;
	background-color: #e0e2e4;
}
.user-list {
	height: 92%;
	overflow-y: auto;
}
.user-list .blue {
	color: #00b0e8;
}
.user-list p {
	margin: 10px;
	display: flex;
	justify-content: space-between;
	color: #656565;
	border-bottom: 1px solid #ccc;
	padding-bottom: 2px;
}
.el-button {
	position: absolute;
	top: 90px;
	right: 45px;
}
/deep/.video-js .vjs-big-play-button {
	top: 50%;
	left: 49%;
}
.userName{
	max-width: 50%;
	font-size: 13px;
}
.isLiveTime{
	font-size: 12px;
}
</style>
